import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  pendingWork: {
    backgroundColor: '#d3e4df',
    color: '#0e3123',
    // @ts-expect-error this is a valid fontweight
    fontWeight: '450',
  },
  paused: {
    backgroundColor: '#fef2d6',
    color: '#644b14',
  },
  assigned: {
    backgroundColor: '#ebebeb',
    color: '#000000',
  },
  resolved: {
    backgroundColor: '#ebebeb',
    color: '#000000',
  },
});
